import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { TagsInput } from 'react-tag-input-component'
interface IProps {
  closeModal: () => void
}
const initialValues = {
  contactNumbers: []
}
const whatsappNumberSchema = Yup.object().shape({
  contactNumbers: Yup.array().of(
    Yup.string()
      .matches(/^[0-9]+$/, 'Contact number must only contain digits')
      .min(10, 'Minimum 10 digits')
      .max(10, 'Maximum 10 digits')
  )
})
const ShareOnWhatsAppModel: React.FC<IProps> = ({ closeModal }) => {
  const [loadingOL, setLoading] = useState(false)
  const formik = useFormik({
    initialValues,
    validationSchema: whatsappNumberSchema,
    onSubmit: (values) => {
      // Handle form submission here
      console.log('Form submitted:', values)
    }
  })
  return (
    <div className='card w-500px h-460px mb-4 position-relative text-center'>
      <button
        type='button'
        className='btn-close position-absolute top-0 end-0 m-n4 rounded-circle'
        aria-label='Close'
        onClick={closeModal}
        style={{
          backgroundColor: 'rgba(218, 222, 243)',
          height: '25px',
          width: '25px',
          color: 'rgba(52, 60, 106)'
        }}
      ></button>
      <div className='d-flex justify-content-between align-items-center px-3 py-2'>
        <h2 className='mb-0'>Share on Whatsapp</h2>
      </div>
      <div className='d-flex justify-content-between align-items-center px-3 py-2'>
        <p className='mb-0'>Enter receiver's number to share on Whatsapp.</p>
      </div>
      <div className='d-flex flex-column mb-10 fv-row fv-plugins-icon-container'>
        <div className='d-flex align-items-start mt-6 px-3 py-2'>
          <label className='fs-6 fw-bold mb-2'>Contact Numbers:</label>
        </div>
        <TagsInput
          value={formik.values.contactNumbers}
          onChange={(tags) => {
            // Filter out non-numeric values
            const numericTags = tags.filter((tag) => /^\d+$/.test(tag))
            formik.setFieldValue('contactNumbers', numericTags)
          }}
          name='contactNumbers'
          placeHolder='Enter contact numbers'
        />
        {formik.touched.contactNumbers && formik.errors.contactNumbers && (
          <div className='d-flex align-items-start mt-1 n2 px-3 py-2'>
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.contactNumbers}</span>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className='d-flex flex-column mb-10 fv-row fv-plugins-icon-container'>
        <div className='d-flex align-items-start mt-n2 px-3 py-2'>
          <label className='fs-6 fw-bold mb-2'>Message:</label>
        </div>
        <textarea
          className='form-control form-control-solid'
          rows={6}
          name='message'
          placeholder='Add an invitation message (optional)'
        ></textarea>
        <div className='fv-plugins-message-container invalid-feedback'></div>
      </div>
      <div className='text-start'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loadingOL && <span className='indicator-label'>Send</span>}
          {loadingOL && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </div>
  )
}
export default ShareOnWhatsAppModel
